import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const UnitWidth = ({ value, onChange, patioDoorType, id = 'UnitWidth', label = 'Unit Width', disabled = false }) => {
    const defaultValue = value?.value || '';
    const [selectedWidth, setSelectedWidth] = useState(defaultValue);

    // Width options based on patio door type
    const widthOptionsByType = {
        Sliding: [
            { id: 1, value: '58 3/4"', label: '58 3/4"' },
            { id: 2, value: '59 1/2"', label: '59 1/2"' },
            { id: 3, value: '70 3/4"', label: '70 3/4"' },
            { id: 4, value: '71 1/2"', label: '71 1/2"' },
            { id: 5, value: '94 3/4"', label: '94 3/4"' },
            { id: 6, value: '95 1/2"', label: '95 1/2"' },
        ],
        TripleSliding: [
            { id: 1, value: '89"', label: '89"' },
            { id: 2, value: '89 1/4"', label: '89 1/4"' },
            { id: 3, value: '107 1/4"', label: '107 1/4"' },
            { id: 4, value: '108"', label: '108"' },
            { id: 5, value: '143 1/4"', label: '143 1/4"' },
            { id: 6, value: '143"', label: '143"' },
        ],
        QuadSliding: [
            { id: 1, value: '116 7/8"', label: '116 7/8"' },
            { id: 2, value: '119 1/8"', label: '119 1/8"' },
            { id: 3, value: '140 7/8"', label: '140 7/8"' },
            { id: 4, value: '143 1/8"', label: '143 1/8"' },
            { id: 5, value: '188 7/8"', label: '188 7/8"' },
            { id: 6, value: '191 1/8"', label: '191 1/8"' },
        ],
    };

    // Get current door type value
    const doorTypeValue = patioDoorType?.value || 'Sliding';
    const widthOptions = widthOptionsByType[doorTypeValue] || widthOptionsByType.Sliding;

    // Update selected value when value prop changes
    useEffect(() => {
        setSelectedWidth(value?.value || '');
    }, [value?.value]);

    // Reset to first option when door type changes (only if current value is not valid)
    useEffect(() => {
        if (widthOptions.length > 0) {
            const propValue = value?.value || selectedWidth;
            const currentValueExists = widthOptions.some(opt => opt.value === propValue);
            if (!currentValueExists) {
                const defaultOption = widthOptions[0];
                setSelectedWidth(defaultOption.value);
                onChange({ value: defaultOption.value, label: defaultOption.label });
            }
        }
    }, [doorTypeValue]);

    // Trigger initial onChange once when component mounts
    useEffect(() => {
        if (widthOptions.length > 0 && !selectedWidth) {
            const defaultOption = widthOptions[0];
            setSelectedWidth(defaultOption.value);
            onChange({ value: defaultOption.value, label: defaultOption.label });
        }
    }, []);

    const handleWidthChange = (option) => {
        setSelectedWidth(option.value);
        onChange({ value: option.value, label: option.label });
    };

    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
        },
        label: {
            fontSize: '12px',
            fontWeight: '500',
            marginBottom: '2px',
        },
        radioGroup: {
            display: 'flex',
            flexDirection: 'column',
            gap: '2px',
        },
        radioLabel: {
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            cursor: disabled ? 'not-allowed' : 'pointer',
            fontSize: '11px',
            padding: '1px 0',
        },
        radioInput: {
            margin: 0,
            width: '12px',
            height: '12px',
            cursor: disabled ? 'not-allowed' : 'pointer',
        },
        radioText: {
            fontSize: '11px',
            color: disabled ? '#999' : '#333',
        },
    };

    return (
        <div style={styles.container}>
            <label style={styles.label} disabled={disabled}>
                {label}
            </label>
            <div style={styles.radioGroup}>
                {widthOptions.map(option => (
                    <label key={option.id} style={styles.radioLabel}>
                        <input
                            type="radio"
                            name={`${id}_${doorTypeValue}`}
                            value={option.value}
                            checked={selectedWidth === option.value}
                            onChange={() => handleWidthChange(option)}
                            disabled={disabled}
                            style={styles.radioInput}
                        />
                        <span style={styles.radioText}>{option.label}</span>
                    </label>
                ))}
            </div>
        </div>
    );
};

export default UnitWidth;
